export type MyIpCanvasSaveStatus = 'pending' | 'saved' | 'error';
const states = new WeakMap<object, MyIpCanvasSaveStatus>();
const listeners = new Set<() => void>();

/** 仅保存编辑器级状态，不缓存账号数据或完整画布。 */
export function getMyIpCanvasSaveStatus(ctx: object): MyIpCanvasSaveStatus | undefined {
  return states.get(ctx);
}

/** 应用和自动保存共用可见失败状态，避免删除失败仅输出控制台。 */
export function setMyIpCanvasSaveStatus(ctx: object, status: MyIpCanvasSaveStatus): void {
  states.set(ctx, status);
  listeners.forEach((listener) => listener());
}

/** 画布卸载时由 React 解除通知订阅。 */
export function subscribeMyIpCanvasSaveStatus(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
